/**
 * Revoked-integrations banner store (TV1-2446 slice 7)
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { initialState, selectors } from './revokedIntegrationsBanner.state';
import { handlers } from './revokedIntegrationsBanner.handlers';
import { createRevokedIntegrationsBannerPolicy } from './policies/revokedIntegrationsBannerPolicy';

const store = createStore({
  name: 'revoked-integrations-banner',
  initialState,
  handlers
});

export const {
  useSelector: useRevokedIntegrationsBannerSelector,
  usePolicies: useRevokedIntegrationsBannerPolicies,
  getState: getRevokedIntegrationsBannerState,
  dispatch: dispatchRevokedIntegrationsBannerCommand
} = store;

/**
 * Policy factory — ONE policy, this store's own subscription. Registered ONCE, in
 * `AuthenticatedLayout`, per the CDSE single-registration-site rule (see `useNavbarPolicies`
 * and friends there for the sibling pattern).
 */
export const createRevokedIntegrationsBannerPolicies = ( backend: ClientLibraryType ) => [
  createRevokedIntegrationsBannerPolicy( backend )
];

export { selectors };
